var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-circle"}),_c('p',{staticClass:"loading-text"},[_vm._t("default",[_vm._v("Carregando")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }